// extracted by mini-css-extract-plugin
export default {"modal":"PositionTemplateModal-module__modal__TJYjt","content":"PositionTemplateModal-module__content__2rDAG"};